import api from '../../api/index'

export const putMissedCall = async (roomId) => {
  const urlEnd = '/v2/tourringhistory/missedCall'
  const method = 'put'
  const response = await api.asyncRequest(urlEnd, method, { roomId })
  return response.ok ? response.data : null
}

export const requestConnection = async (payload) => {
  const urlEnd = '/v2/tourringhistory/requestConnection'
  const method = 'post'
  const response = await api.asyncRequest(urlEnd, method, payload)
  return response.ok ? response.data : null
}
